export const campaignJobBoardQueryKeys = {
  all: ["campaignJobBoards"] as const,
  lists: () => [...campaignJobBoardQueryKeys.all, "list"] as const,
  list: (campaignId: string, clientId?: string) =>
    [...campaignJobBoardQueryKeys.lists(), campaignId, clientId] as const,
  infinites: () => [...campaignJobBoardQueryKeys.all, "infinite"] as const,
  infinite: (
    campaignId: string,
    clientId?: string,
    statuses?: string[],
    search?: string
  ) =>
    [
      ...campaignJobBoardQueryKeys.infinites(),
      campaignId,
      clientId,
      statuses,
      search,
    ] as const,
  details: () => [...campaignJobBoardQueryKeys.all, "detail"] as const,
  detail: (campaignId: string, clientIntegrationModuleId: string, clientId?: string) =>
    [
      ...campaignJobBoardQueryKeys.details(),
      campaignId,
      clientIntegrationModuleId,
      clientId,
    ] as const,
  months: {
    all: ["campaignJobBoardMonths"] as const,
    list: (params?: {
      clientId?: string;
      descending?: boolean;
      month?: string;
      orderBy?: string;
      page?: number;
      pageSize?: number;
      year?: string;
    }) =>
      [
        ...campaignJobBoardQueryKeys.months.all,
        params?.clientId,
        params?.descending,
        params?.month,
        params?.orderBy,
        params?.page,
        params?.pageSize,
        params?.year,
      ] as const,
  },
  monthsByJobBoard: {
    all: ["campaignJobBoardMonthsByJobBoard"] as const,
  },
  budgetMinimums: (campaignId: string, clientIntegrationModuleId: string) =>
    [...campaignJobBoardQueryKeys.all, "budgetMinimums", campaignId, clientIntegrationModuleId] as const,
  clientBudgetMonth: {
    all: ["clientBudgetMonth"] as const,
    byClient: (clientId?: string) =>
      [...campaignJobBoardQueryKeys.clientBudgetMonth.all, clientId] as const,
    detail: (clientId?: string, year?: string, month?: string) =>
      [
        ...campaignJobBoardQueryKeys.clientBudgetMonth.all,
        clientId,
        year,
        month,
      ] as const,
  },
};
